export const BancorNetworkAbi = [
    {
       "constant":false,
       "inputs":[
          {
             "name":"_token",
             "type":"address"
          },
          {
             "name":"_register",
             "type":"bool"
          }
       ],
       "name":"registerEtherToken",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_signerAddress",
             "type":"address"
          }
       ],
       "name":"setSignerAddress",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          }
       ],
       "name":"getReturnByPath",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          },
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_CONVERTER_UPGRADER",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_block",
             "type":"uint256"
          },
          {
             "name":"_nonce",
             "type":"uint256"
          },
          {
             "name":"_v",
             "type":"uint8"
          },
          {
             "name":"_r",
             "type":"bytes32"
          },
          {
             "name":"_s",
             "type":"bytes32"
          }
       ],
       "name":"convertForPrioritized",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BNT_TOKEN",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"CONTRACT_REGISTRY",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_affiliateAccount",
             "type":"address"
          },
          {
             "name":"_affiliateFee",
             "type":"uint256"
          }
       ],
       "name":"claimAndConvertFor2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_signature",
             "type":"uint256[]"
          },
          {
             "name":"_affiliateAccount",
             "type":"address"
          },
          {
             "name":"_affiliateFee",
             "type":"uint256"
          }
       ],
       "name":"convertForPrioritized4",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_affiliateAccount",
             "type":"address"
          },
          {
             "name":"_affiliateFee",
             "type":"uint256"
          }
       ],
       "name":"convert2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_CONVERTER_FACTORY",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"signerAddress",
       "outputs":[
          {
             "name":"",
             "type":"address"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"maxAffiliateFee",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_token",
             "type":"address"
          },
          {
             "name":"_to",
             "type":"address"
          },
          {
             "name":"_amount",
             "type":"uint256"
          }
       ],
       "name":"withdrawTokens",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BNT_CONVERTER",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_toBlockchain",
             "type":"bytes32"
          },
          {
             "name":"_to",
             "type":"bytes32"
          },
          {
             "name":"_conversionId",
             "type":"uint256"
          },
          {
             "name":"_block",
             "type":"uint256"
          },
          {
             "name":"_v",
             "type":"uint8"
          },
          {
             "name":"_r",
             "type":"bytes32"
          },
          {
             "name":"_s",
             "type":"bytes32"
          }
       ],
       "name":"xConvertPrioritized",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_block",
             "type":"uint256"
          },
          {
             "name":"_v",
             "type":"uint8"
          },
          {
             "name":"_r",
             "type":"bytes32"
          },
          {
             "name":"_s",
             "type":"bytes32"
          }
       ],
       "name":"convertForPrioritized2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_FORMULA",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
 
       ],
       "name":"acceptOwnership",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"registry",
       "outputs":[
          {
             "name":"",
             "type":"address"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
          {
             "name":"",
             "type":"address"
          }
       ],
       "name":"etherTokens",
       "outputs":[
          {
             "name":"",
             "type":"bool"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"CONTRACT_FEATURES",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "name":"conversionHashes",
       "outputs":[
          {
             "name":"",
             "type":"bool"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"owner",
       "outputs":[
          {
             "name":"",
             "type":"address"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_NETWORK",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_GAS_PRICE_LIMIT",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"CONVERTER_CONVERSION_WHITELIST",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_registry",
             "type":"address"
          }
       ],
       "name":"setRegistry",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_affiliateAccount",
             "type":"address"
          },
          {
             "name":"_affiliateFee",
             "type":"uint256"
          }
       ],
       "name":"convertFor2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          }
       ],
       "name":"claimAndConvertFor",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          },
          {
             "name":"_customVal",
             "type":"uint256"
          },
          {
             "name":"_block",
             "type":"uint256"
          },
          {
             "name":"_v",
             "type":"uint8"
          },
          {
             "name":"_r",
             "type":"bytes32"
          },
          {
             "name":"_s",
             "type":"bytes32"
          }
       ],
       "name":"convertForPrioritized3",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_X",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_toBlockchain",
             "type":"bytes32"
          },
          {
             "name":"_to",
             "type":"bytes32"
          },
          {
             "name":"_conversionId",
             "type":"uint256"
          }
       ],
       "name":"xConvert",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          }
       ],
       "name":"claimAndConvert",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_for",
             "type":"address"
          }
       ],
       "name":"convertFor",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"BANCOR_X_UPGRADER",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_toBlockchain",
             "type":"bytes32"
          },
          {
             "name":"_to",
             "type":"bytes32"
          },
          {
             "name":"_conversionId",
             "type":"uint256"
          },
          {
             "name":"_signature",
             "type":"uint256[]"
          }
       ],
       "name":"xConvertPrioritized2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"newOwner",
       "outputs":[
          {
             "name":"",
             "type":"address"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          },
          {
             "name":"_affiliateAccount",
             "type":"address"
          },
          {
             "name":"_affiliateFee",
             "type":"uint256"
          }
       ],
       "name":"claimAndConvert2",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_newOwner",
             "type":"address"
          }
       ],
       "name":"transferOwnership",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_path",
             "type":"address[]"
          },
          {
             "name":"_amount",
             "type":"uint256"
          },
          {
             "name":"_minReturn",
             "type":"uint256"
          }
       ],
       "name":"convert",
       "outputs":[
          {
             "name":"",
             "type":"uint256"
          }
       ],
       "payable":true,
       "stateMutability":"payable",
       "type":"function"
    },
    {
       "constant":false,
       "inputs":[
          {
             "name":"_maxAffiliateFee",
             "type":"uint256"
          }
       ],
       "name":"setMaxAffiliateFee",
       "outputs":[
 
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"function"
    },
    {
       "constant":true,
       "inputs":[
 
       ],
       "name":"NON_STANDARD_TOKEN_REGISTRY",
       "outputs":[
          {
             "name":"",
             "type":"bytes32"
          }
       ],
       "payable":false,
       "stateMutability":"view",
       "type":"function"
    },
    {
       "inputs":[
          {
             "name":"_registry",
             "type":"address"
          }
       ],
       "payable":false,
       "stateMutability":"nonpayable",
       "type":"constructor"
    },
    {
       "anonymous":false,
       "inputs":[
          {
             "indexed":true,
             "name":"_prevOwner",
             "type":"address"
          },
          {
             "indexed":true,
             "name":"_newOwner",
             "type":"address"
          }
       ],
       "name":"OwnerUpdate",
       "type":"event"
    }
 ]